import { useMemo } from "react";
import { DropdownFacetType, FacetChangeEvent } from "../../SearchFilterResultData";

export function resetSelectFacet(facet: DropdownFacetType): DropdownFacetType {
  const newItems = facet.items.map((item) => ({ ...item, selected: false }));

  return { ...facet, items: newItems };
}

function selectItem(facet: DropdownFacetType, selectedValue: string): DropdownFacetType {
  const newItems = facet.items.map((item) => ({ ...item, selected: item.value === selectedValue }));

  return { ...facet, items: newItems };
}

type SelectProps = {
  facet: DropdownFacetType;
  onChange: FacetChangeEvent;
  disabled?: boolean;
};

export function Select({ facet, onChange, disabled }: SelectProps) {
  const value = useMemo(
    () => facet.items.find((item) => item.selected)?.value || "",
    [facet.items]
  );

  function handleChange(selectedValue: string) {
    const newFacet = selectItem(facet, selectedValue);

    onChange(newFacet);
  }

  return (
    <label className="facet-select" htmlFor={facet.id}>
      <span className="visually-hidden">{facet.placeholder}</span>
      <select
        id={facet.id}
        disabled={disabled}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      >
        {facet.placeholder && (
          <option value="" disabled>
            {facet.placeholder}
          </option>
        )}
        {facet.none && value != "" && <option value="">{facet.none}</option>}
        {facet.items.map((item, index) => (
          <option key={index} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>
    </label>
  );
}
